import { render, staticRenderFns } from "./ConfiguracionBotones.vue?vue&type=template&id=736b2b0f&"
import script from "./ConfiguracionBotones.vue?vue&type=script&lang=js&"
export * from "./ConfiguracionBotones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports